import { Injectable } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { collection, collectionData, doc, docData, DocumentReference, Firestore, orderBy, query } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { pluck, switchMap } from 'rxjs/operators';

import { SquadWithId } from '@innersight-os/shared/firestore-interfaces';
import { DocumentData } from '@firebase/firestore-types';

@Injectable({
  providedIn: 'root'
})
export class SquadsService {
  allSquads$ = collectionData(
    query<SquadWithId, DocumentData>(
      // eslint-able-next-line @typescript-eslint/no-explicit-any
      collection(this.db, 'squads') as any,
      orderBy('name', 'asc')
    ),
    {idField: 'id'},
  )

  mySquad$: Observable<SquadWithId | null> = authState(this.auth).pipe(
    pluck('uid'),
    switchMap(uid =>
      docData<SquadWithId>(doc(this.db, `squads/${uid}`) as DocumentReference<SquadWithId>, {idField: 'id'})
    ),
  )

  constructor(
    private auth: Auth,
    private db: Firestore,
  ) {}
}
